import React, { useEffect, useRef } from "react";
import { Headline, HeadlineContainer } from "../styles/components/Global/Text";
import {
  Container,
  HeadlineVideo,
  VideoLanding,
} from "../styles/components/Galleries/Scale";
import animations from "./Animations";
import LotusVideo from "./Video";

const GalleryScale = () => {
  const containerRef = useRef(null);
  const headingRef = useRef(null);
  const videoLandingRef = useRef(null);

  useEffect(() => {
    animations.galleryScale(
      containerRef.current,
      headingRef.current,
      videoLandingRef.current
    );
  }, []);

  return (
    <Container ref={containerRef}>
      <LotusVideo scale="true" autoplay="false" />
      <HeadlineContainer ref={headingRef}>
        <HeadlineVideo>
          <Headline $textAlign="left">LOTUS &</Headline>
          <VideoLanding ref={videoLandingRef}></VideoLanding>
        </HeadlineVideo>
        <Headline $textAlign="left">
          & DIGITAL ARTIST KSAWERY UNITE THEIR TALENT
        </Headline>
      </HeadlineContainer>
    </Container>
  );
};

export default GalleryScale;
